<template>
  <div class="widgets-wrapper" style="height:100%;">
    
    <widget-menu  @switchToWidgetEvent="selectWidget"></widget-menu>
    <div class="widgets-area" v-if="currentWidget">
      <!-- HTML CASE -->
      
      <widget
        :widget-data="currentWidget"
        v-if="currentWidget.html && currentWidget.type === 'HTML'"
       >
          <div slot="content" v-html="currentWidget.html" class="widget-content widget-content--html"></div>
      </widget>
      

      <!-- Iframe CASE -->
      <widget
        :widget-data="currentWidget"
        v-if="currentWidget.iframeUrl && currentWidget.type === 'Iframe'"
        >
          <div slot="content" class="widget-content widget-content--iframe">
            <iframe :src="currentWidget.iframeUrl" frameborder="0" width="100%"></iframe>
          </div>
      </widget>
      

      <!-- QNA CASE -->
      <widget
        :widget-data="currentWidget"
        v-if="currentWidget.type === 'Q&A'"
        >
          <div slot="content" class="widget-content widget-content--qna">
            <qna-widget :widget-data="currentWidget" />
          </div>
      </widget>
      
    </div>
  </div>
</template>

<script>
import {mapState, mapGetters, mapActions} from 'vuex'
import Widget from '@/components/widgets/Widget.vue'
import WidgetMenu from '@/components/widgets/WidgetMenu.vue'
import QnaWidget from '@/components/qna/QnaWidget.vue'

export default {
  data() {
    return {
      currentWidget: null,
      isReady: false
    };
  },
  components: {
    Widget,
    QnaWidget,
    WidgetMenu
  },
  computed:{
    ...mapGetters('webcast', {
      webcast: 'getCopy',
    }),
    ...mapGetters('widgets', {
      findWidgetsInStore: 'find'
    }),
    widgets () {
      return this.findWidgetsInStore().data
    }
  },
  methods:{
    ...mapActions('widgets', {
      findWidgetsAction: 'find'
    }),
    selectWidget(index){
      this.currentWidget = this.widgets[index]
    }
  },
  created(){
    // set the first widgetType by default
      if (this.widgets && this.widgets.length) {
        this.$set(this.$data, 'currentWidget', this.widgets[0]);
      }

  }
}
</script>

<style lang="less"> 
  .widgets {
    &-area {
      height: 100%;
      .widget {
        height: 100%;
        iframe {
          width: 100%;
          height: 100%;
        }
      }
    }

    &-list {
      display: flex;
      flex-wrap: wrap;
      list-style: none;
      margin-bottom: 0;
      margin-right: 10px;
      font-weight: bold;
      cursor: pointer;
      > li {
        &:not(:last-of-type) {
          margin-right: 20px;
        }
      }
    }
  }
  
  @media screen and (max-width: 992px) {
    .widgets-wrapper{
      height: 100%;
      /*padding-top: 48px;*/
    }

    .widget-content {
      height: 100%;
      padding-bottom: 56px;
      //height: ~"calc(100vh - (45vh + 30px + 46px))";
      &:not(.widget-content--iframe) {
        //padding: 0;
      }
    }
    
  }
</style>
